<template>
  <div>
    <PageMain
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData()"
      @openEdit="openEdit"
      @del="del"
    >
      <template #header>
        <div class="d-flex align-items-stretch">
          <div class="side-frame-warning"></div>
          <div class="d-flex align-items-center">
            <span style="font-size: 14px; color: #606266">
              {{ $l('table_header_brand') || '客户品牌' }}
            </span>
            <el-divider direction="vertical" v-if="!disabled" />
            <b-button
              v-if="!disabled"
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="openEdit({ type: 'add' })"
            >
              {{ $l('btn_addBrand') || '新增品牌' }}
            </b-button>
          </div>
        </div>
      </template>
    </PageMain>

    <EditForm
      :visible.sync="editFormOpts.visible"
      :type="editFormOpts.type"
      :custBrandCode="editFormOpts.custBrandCode"
      :custCode="custCode"
      @reload="getData()"
    />

    <AddBrand
      :visible.sync="addBrandVisible"
      :custCode="custCode"
      @reload="getData()"
    />
  </div>
</template>
<script>
import PageMain from './main'
import EditForm from './components/edit-form'
import AddBrand from './components/add-brand'
import EditLoading from '@/mixins/edit-loading'
export default {
  components: { PageMain, EditForm, AddBrand },
  mixins: [EditLoading],
  props: {
    custCode: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      editFormOpts: { visible: false, type: '', custBrandCode: '' },
      addBrandVisible: false,
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      this.loading = true
      const res = await this.$api
        .masterCustomerBrandListApi({ custCode: this.custCode })
        .catch(() => null)
      this.loading = false
      this.tableData = res?.body?.data || []
    },
    openEdit({ type, row: { custBrandCode = '' } = {} } = {}) {
      if (type == 'add') return (this.addBrandVisible = true)
      this.editFormOpts = { visible: true, type, custBrandCode }
    },
    async del({ custBrandCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return
      const res = await this.$api
        .masterCustomerBrandDelApi({ custBrandCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.getData()
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-warning {
  padding: 1px 5px;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
